module.exports = __webpack_public_path__ + "img/gmultiple.83205f8.webp";